export const APPLICATION_SUMMARY_LIST = "APPLICATION_SUMMARY_LIST";
export const APPLICATION_SUMMARY_LIST_FETCH_FAILED = "APPLICATION_SUMMARY_LIST_FETCH_FAILED";
export const SET_APPLICATIONS_SUMMARY_LOADING = "SET_APPLICATIONS_SUMMARY_LOADING"
export const APPLICATION_SUMMARY_NO_FILTER_DATA = "APPLICATION_SUMMARY_NO_FILTER_DATA";

export const APPLICATION_SUMMARY_FILTERS_LIST = "APPLICATION_SUMMARY_FILTERS_LIST";
export const APPLICATION_SUMMARY_FILTERS_LIST_FETCH_FAILED = "APPLICATION_SUMMARY_FILTERS_LIST_FETCH_FAILED";
export const APPLICATION_SUMMARY_FILTERS_LIST_LOADING = "APPLICATION_SUMMARY_FILTERS_LIST_LOADING";

export const APPLICATION_SUMMARY_FILTERS_SEARCH = "APPLICATION_SUMMARY_FILTERS_SEARCH";
export const APPLICATION_SUMMARY_FILTERS_SEARCH_FAILED = "APPLICATION_SUMMARY_FILTERS_SEARCH_FAILED";
export const APPLICATION_SUMMARY_FILTERS_SEARCH_LOADING = "APPLICATION_SUMMARY_FILTERS_SEARCH_LOADING";
export const APPLICATION_SUMMARY_FILTERS_SEARCH_NORECORDS = "APPLICATION_SUMMARY_FILTERS_SEARCH_NORECORDS";

export const SHOW_PAGINATION_PROGRESS = "SHOW_PAGINATION_PROGRESS";

export const APPLICATIONS_PDF_FETCH_FAILED = "APPLICATIONS_PDF_FETCH_FAILED";

export const APPLICATION_STATEMENT_FETCH_FAILED = "APPLICATION_STATEMENT_FETCH_FAILED";

export const APPLICATIONS_SUMMARY_SEARCH = "APPLICATIONS_SUMMARY_SEARCH";
export const APPLICATIONS_SUMMARY_SEARCH_FAILED = "APPLICATIONS_SUMMARY_SEARCH_FAILED";

export const DELEGATE_LIST_FETCH = "DELEGATE_LIST_FETCH";
export const SET_DELEGATE_LIST_LOADING = "SET_DELEGATE_LIST_LOADING";
export const TRANSFER_SUCCESS = "TRANSFER_SUCCESS";
export const IND_TRANSFER__INPROGRESS = "IND_TRANSFER__INPROGRESS";
export const IND_TRANSFER_SUCCESS = "IND_TRANSFER_SUCCESS";
export const IND_TRANSFER_FAILED = "IND_TRANSFER_FAILED";
export const SET_MODAL_CONTENT = "SET_MODAL_CONTENT";
export const DELETE_APP_SUCCESS = "DELETE_APP_SUCCESS";
export const EDIT_OWNERSHIP_SUCCESS = "EDIT_OWNERSHIP_SUCCESS";
export const APPLICATIONS_PDF_FETCH_SUCCESS = "APPLICATIONS_PDF_FETCH_SUCCESS";

export const APPLICATION_SUMMARY_NEW_FILTERS_SEARCH = "APPLICATION_SUMMARY_NEW_FILTERS_SEARCH";
export const APPLICATION_SUMMARY_NEW_FILTERS_SEARCH_FAILED = "APPLICATION_SUMMARY_NEW_FILTERS_SEARCH_FAILED";
export const SET_APLICATION_REST_PROPS = "SET_APLICATION_REST_PROPS";
export const APPLICATION_DETAIL = "APPLICATION_DETAIL";
export const APPLICATIONS_DETAIL_FETCH_FAILED = "APPLICATIONS_DETAIL_FETCH_FAILED";
export const APP_STATUS_DESC_LIST_FETCH_SUCCESS = "APP_STATUS_DESC_LIST_FETCH_SUCCESS";
export const APP_STATUS_DESC_LIST_FETCH_FAILURE = "APP_STATUS_DESC_LIST_FETCH_FAILURE";
export const SET_MARKET_INFO = "SET_MARKET_INFO";
export const SET_STATES_INFO = "SET_STATES_INFO";